export default __webpack_public_path__ + "static/media/item_2.65374b89.png";